import React from 'react';

const DailyRecapReportLoadable = React.lazy(() => import('./DailyRecapReport'));
const CustomerReportComponentLoadable = React.lazy(() => import('./CustomerReportComponent'))
const LifeScienceReportComponentLoadable = React.lazy(() => import('./LifeScienceReport'))

export {
    DailyRecapReportLoadable,
    CustomerReportComponentLoadable,
    LifeScienceReportComponentLoadable
}